<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

import PageWrapper from "@/common/components/PageWrapper.vue";
import RosterActionMenu from "@/teams/components/RosterActionMenu.vue";
import { useGetRosterByIdQuery } from "@/teams/rosters/api/queries";

definePage({
  meta: {
    auth: ["Admin.Access"],
  },
});

const route = useRoute("/teams/[teamId].rosters/[rosterId]");
const rosterId = computed(() => route.params.rosterId);
const teamId = computed(() => route.params.teamId);

const { data: roster, isPending } = useGetRosterByIdQuery(rosterId);

const breadcrumbs = computed(() => [
  { label: "Teams", to: "/teams/list" },
  {
    label: `${roster.value?.team?.name ?? "Team"}`,
    to: `/teams/${roster.value?.teamId}/details`,
  },
  { label: "Rosters", to: `/teams/${roster.value?.teamId}/rosters` },
  { label: roster.value?.seasonLeague?.name ?? "Roster", to: "#" },
]);

const tabs = computed(() => [
  {
    title: "Details",
    to: `/teams/${teamId.value}/rosters/${rosterId.value}/details`,
  },
  {
    title: "Activity",
    to: `/teams/${teamId.value}/rosters/${rosterId.value}/activity-log`,
  },
]);
</script>

<template>
  <PageWrapper
    :title="roster?.seasonLeague?.name ?? 'Default'"
    :is-pending="isPending"
    :breadcrumb-links="breadcrumbs"
    :tabs="tabs"
  >
    <template #actions>
      <RosterActionMenu
        v-if="roster"
        :roster="roster"
      />
    </template>
    <div
      v-if="roster && roster.isArchived"
      class="bg-red-200 text-center my-5 rounded-md"
    >
      <h1 class="p-5 text-red-800 font-bold">This roster has been archived!</h1>
    </div>
    <RouterView v-slot="{ Component }">
      <Transition
        mode="out-in"
        name="fade"
      >
        <component
          :is="Component"
          v-if="roster"
          :roster="roster"
        />
      </Transition>
    </RouterView>
  </PageWrapper>
</template>
